import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { XCircle } from 'lucide-react';

const SubscriptionCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 flex items-center justify-center p-4">
      <Card className="max-w-md w-full">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl">Payment Cancelled</CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-6">
          <XCircle className="w-16 h-16 mx-auto text-orange-600" />
          <div className="space-y-2">
            <p className="text-lg font-semibold text-gray-900">
              Your payment was cancelled
            </p>
            <p className="text-gray-600">
              No charges were made to your account. You can try again whenever you're ready.
            </p>
          </div>
          <div className="flex gap-3">
            <Button
              onClick={() => navigate('/plans')}
              className="flex-1 bg-indigo-600 hover:bg-indigo-700"
            >
              Try Again
            </Button>
            <Button
              onClick={() => navigate('/dashboard')}
              variant="outline"
              className="flex-1"
            >
              Back to Home
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SubscriptionCancel;
